export default function NotFound() {
  return <div>NotFound</div>;
}
